/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'http-policy-set';

export const httpPolicySetModalBreadcrumbTitle = `${prefix}.httpPolicySetModalBreadcrumbTitle`;
export const httpSecurityRuleModalBreadcrumbTitle = `${prefix}.httpSecurityRuleModalBreadcrumbTitle`;
export const httpRequestRuleModalBreadcrumbTitle = `${prefix}.httpRequestRuleModalBreadcrumbTitle`;
export const httpResponseRuleModalBreadcrumbTitle = `${prefix}.httpResponseRuleModalBreadcrumbTitle`;
export const withLabel = `${prefix}.withLabel`;

export const ENGLISH = {
    [httpPolicySetModalBreadcrumbTitle]: 'HTTP Policy Set',
    [httpSecurityRuleModalBreadcrumbTitle]: 'HTTP Security Rule',
    [httpRequestRuleModalBreadcrumbTitle]: 'HTTP Request Rule',
    [httpResponseRuleModalBreadcrumbTitle]: 'HTTP Response Rule',
    [withLabel]: 'with',
};
